import { HttpTypes } from "@medusajs/types"

// product.metadata.related = { shroud?: string[], radiators?: string[],
// fans?: string[], relay?: string[], accessories?: string[] } (variant SKU lists).
export type RelatedMetadata = {
  shroud?: string[]
  radiators?: string[]
  fans?: string[]
  relay?: string[]
  accessories?: string[]
}

// Cross-sell slots in pitch order. Radiators are alternates, not upsells,
// so they are excluded from the upsell/quick-add flows.
export const UPSELL_SLOTS: (keyof RelatedMetadata)[] = [
  "shroud",
  "fans",
  "relay",
  "accessories",
]

export const toSkuList = (value: unknown): string[] => {
  if (!Array.isArray(value)) {
    return []
  }

  return value.filter(
    (sku): sku is string => typeof sku === "string" && !!sku.trim()
  )
}

// Ordered, deduped upsell SKUs (shroud -> fans -> relay -> accessories)
// pulled from product.metadata.related.
export const getUpsellSkus = (product: HttpTypes.StoreProduct): string[] => {
  const related = product.metadata?.related as RelatedMetadata | undefined

  if (!related || typeof related !== "object") {
    return []
  }

  return Array.from(
    new Set(UPSELL_SLOTS.flatMap((slot) => toSkuList(related[slot])))
  )
}

// Reorders resolved SKU matches back into the given SKU order, deduping
// products that match more than one SKU.
export const orderProductsBySkus = <T extends { id: string; matched_sku: string }>(
  skus: string[],
  products: T[]
): T[] => {
  const bySku = new Map(products.map((p) => [p.matched_sku, p]))
  const seen = new Set<string>()
  const ordered: T[] = []

  for (const sku of skus) {
    const match = bySku.get(sku)

    if (match && !seen.has(match.id)) {
      seen.add(match.id)
      ordered.push(match)
    }
  }

  return ordered
}
